export enum ActionTypes {
    FetchUserShortcuts = "FETCH_USER_SHORTCUTS",
    FetchUserShortcutsPending = "FETCH_USER_SHORTCUTS_PENDING",
    FetchUserShortcutsRejected = "FETCH_USER_SHORTCUTS_REJECTED",
    FetchUserShortcutsFulfilled = "FETCH_USER_SHORTCUTS_FULFILLED",
}
